export { QiniuErrorName, QiniuError, QiniuRequestError, QiniuNetworkError } from './errors';
export { imageMogr2, watermark, imageInfo, exif, pipeline } from './image';
export { deleteUploadedChunks, getUploadUrl } from './api';
export { default as upload } from './upload';
export { region } from './config';
export { compressImage, urlSafeBase64Encode, urlSafeBase64Decode, getHeadersForMkFile, getHeadersForChunkUpload } from './utils';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_qiniu-js@3.4.1@qiniu-js/esm/index.js
// module id = 1251
// module chunks = 354